export type EmailTemplateKind = 'proposal' | 'quotation' | 'invoice' | 'credit_note' | 'purchase_order';

export const CREDIT_NOTE_EMAIL = {
  subject: 'Credit note {{number}}',
  body: 'Dear Accounts Payable,\n\nPlease find attached credit note {{number}} for invoice {{title}}.\n\nMany thanks,',
};

export interface EmailTemplate {
  id: string;
  name: string;
  kind: EmailTemplateKind;
  subject: string;
  body: string;
}

export interface SupplierTemplate {
  id: string;
  name: string;
  contactName: string;
  contactRole: string;
  contactEmail: string;
  contactPhone: string;
}

export function poPhrase(numbers: string[]): string {
  const unique = [...new Set(numbers.map((value) => value.trim()).filter(Boolean))];
  if (!unique.length) return '';
  if (unique.length === 1) return `PO: ${unique[0]}`;
  return `POs: ${unique.join(', ')}`;
}

export function renderEmailTemplate(template: string, values: { number?: string; customer?: string; title?: string; pos?: string[] }): string {
  const po = poPhrase(values.pos || []);
  let text = template
    .replace(/\{\{number\}\}/g, values.number || '')
    .replace(/\{\{customer\}\}/g, values.customer || '')
    .replace(/\{\{title\}\}/g, values.title || '')
    .replace(/\{\{po\}\}/g, po);
  if (!po) text = text.replace(/[ \t]+against(?=[ \t]*$)/gm, '');
  return text.replace(/[ \t]+$/gm, '');
}
